const branches = 
{
  lassalchiskikejav: 
  {    
    center    : [-0.187454, -78.508644],
    zoom      : 12
  },
};

export default branches;